module.exports = __webpack_public_path__ + "img/weihuiyuan@2x.88e67564.png";